import { getPricings, Pricings } from './getPricings';

/** A missing offer is unavailable, never an implicit free service. */
export async function getCoachingPricing(savePricings: (pricings: Pricings[]) => void): Promise<Pricings> {
  const pricings = await getPricings();
  savePricings(pricings);
  const pricing = pricings.find((offer) => offer.is_active && offer.case_types.includes('oral_health_coaching'));
  if (!pricing) {
    throw new Error('Oral Health Coaching is currently unavailable for your account. Please contact support.');
  }
  return pricing;
}
